import apiFetch from '../apiFetch'

export default function (token, filter) {
  return apiFetch({ endPoint: 'ProcessingAgencyCommunicationServices', method: 'GET', body: null, token: token })
}
